export default __webpack_public_path__ + "static/media/Mark-3-Suit-08.cc1e3e3d.jpg";